'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Image from 'next/image'
import { FC, ReactNode } from 'react'

import FullScreenOnMobileWrapper from '@/components/FullScreenOnMobileWrapper'

const BlueBox: FC<{
    text: ReactNode
    subText?: ReactNode
    rightSide: ReactNode
    customBackgroundImg?: string
}> = ({ text, subText, rightSide, customBackgroundImg }) => {
    const { smScreen, mdScreen, xsScreen } = useDevice()

    return (
        <FullScreenOnMobileWrapper>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    ...(smScreen
                        ? {
                              pt: 6,
                              pb: 6,
                              pl: xsScreen ? 3 : 6,
                              pr: xsScreen ? 3 : 6,
                              borderRadius: 'none',
                          }
                        : {
                              pt: 8,
                              pb: 8,
                              pl: 9,
                              pr: 9,
                              borderRadius: '32px',
                          }),
                    img: {
                        position: 'absolute',
                        top: 0,
                        width: 'auto',
                        height: 'auto',
                        zIndex: -1,
                        right: '-50%',
                        left: '-50%',
                        margin: 'auto',
                    },
                }}
            >
                <Image
                    src={customBackgroundImg ?? '/images/blue-box/blue-box-gradient-desktop.webp'}
                    width={2400}
                    height={700}
                    alt={`${text}-image`}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: smScreen ? 'flex-start' : 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        flexDirection: smScreen ? 'column' : 'row',
                        gap: smScreen ? 4 : 6,
                    }}
                >
                    <Box
                        sx={{
                            flex: '0 1 auto',
                        }}
                    >
                        <Text variant={mdScreen ? 'h5' : 'h4'}>{text}</Text>
                        {subText && (
                            <Text variant={'body2'} sx={{ mt: 4 }}>
                                {subText}
                            </Text>
                        )}
                    </Box>
                    <Box
                        sx={{
                            flex: '0 1 auto',
                            width: smScreen ? '100%' : 'auto',
                        }}
                    >
                        {' '}
                        {rightSide}
                    </Box>
                </Box>
            </Box>
        </FullScreenOnMobileWrapper>
    )
}

export default BlueBox
